import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import Grid from "@material-ui/core/Grid";
import { useTranslation } from "react-i18next";
import Avatar from "@material-ui/core/Avatar";
import Typography from "@material-ui/core/Typography";
import { Button } from "@material-ui/core";
import Card from "@material-ui/core/Card";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Tooltip from "@material-ui/core/Tooltip";
import IconButton from "@material-ui/core/IconButton";
import LoadingButton from "components/LoadingButton";
import DescriptionIcon from "@material-ui/icons/Description";
import Paper from "@material-ui/core/Paper";
import AccountCircle from "@material-ui/icons/AccountCircle";
import get from "lodash/get";
import { useHistory } from "react-router";
import isEmpty from "lodash/isEmpty";
import DropzoneArea from "components/DropZoneArea";
import { toast, currencyFormat, isSupplierOnly } from "utils";
import { EXTENTIONS_INVOICES } from "utils/constants";
import CardHeader from "@material-ui/core/CardHeader";
import { getApi } from "redux/store";
import useStyles from "./style";
import {
	fetchSupplier,
	fetchSupplierInvoices,
	invoicesTotalAmountsBySupplier,
	invoicesVATAmountsBySupplier,
} from "../../redux/actions/suppliers";
import {
	downloadXMLInvoice,
	fetchCountInvoices,
	fetchCountSuppliers,
	invoicesTotalAmounts,
	fetchInvoices,
	downloadInvoicesExcel,
	invoicesTotalAmountsOverDueBySupplier,
	createInvoice,
} from "../../redux/actions/invoices";
import PaidInvoice from "../Home/components/PaidInvoicesNew";
import UnpaidInvoice from "../Home/components/UnpaidInvoicesNew";
import InvoicesTable from "../Home/components/InvoicesTable";
import SubPageContainer from "../../components/SubPageContainer";
import SubPagePanel from "../../components/SubPagePanel";
import OrderTable from "./Component/OrderTable";
import { fetchOrdersBySupplier } from "../../redux/actions/orders";
import { fetchDeliveryItemsBySupplier } from "../../redux/actions/delivery";
import { DetailsSupplierGeneral } from "./Component/DetailsSupplier/DetailsSupplierGeneral";
import { DetailsLegalInformation } from "./Component/DetailsSupplier/DetailsLegalInformation";
import { DetailsSupplierContact } from "./Component/DetailsSupplier/DetailsSupplierContact";
import { DetailsFinancialInformations } from "./Component/DetailsSupplier/DetailsFinancialInformations";
import CircularLoader from "../../components/Loaders/CircularLoader";

function a11yProps(index) {
	return {
		id: `supplier-detail-tab-${index}`,
		"aria-controls": `supplier-detail-tabpanel-${index}`,
	};
}

function SupplierDetails(props) {
	const classes = useStyles();
	const { t } = useTranslation();
	const dispatch = useDispatch();
	const history = useHistory();
	const [isLoading, setIsLoading] = React.useState({
		excel: false,
	});
	const [value, setValue] = React.useState(0);
	const [valueI, setValueI] = React.useState(0);
	const [expanded, setExpanded] = React.useState(false);
	const supplier = useSelector(({ requests }) => get(requests.queries, "FETCH_SUPPLIER.data"));

	const supplierInvoices = useSelector(({ requests }) =>
		get(requests.queries, "FETCH_SUPPLIER_INVOICES.data")
	);

	const totalInvoicesAmount = useSelector(({ requests }) =>
		get(requests.queries, "INVOICE_TOTAL_AMOUNT_BY_SUPPLIER.data")
	);
	const totalInvoicesAmountPayed = useSelector(({ requests }) =>
		get(requests.queries, "INVOICE_TOTAL_AMOUNT_BY_SUPPLIER_EXPORTED.data")
	);

	const totalInvoicesAmountUnpaid = useSelector(({ requests }) =>
		get(requests.queries, "INVOICE_TOTAL_AMOUNT_BY_SUPPLIER_UNPAID.data")
	);
	const totalVatAmount = useSelector(({ requests }) =>
		get(requests.queries, "INVOICE_VAT_AMOUNT_BY_SUPPLIER_EXPORTED.data")
	);
	const currentUser = useSelector(({ requests }) =>
		get(requests, "queries.FETCH_CURRENT_USER.data")
	);

	const orders = useSelector(({ requests }) =>
		get(requests.queries, "FETCH_ORDER_BY_SUPPLIER.data")
	);
	const totalAmountsOverDueBySupplier = useSelector(
		({ requests }) =>
			requests.queries.INVOICE_TOTAL_OVERDUE_AMOUNT_BY_SUPPLIER &&
			requests.queries.INVOICE_TOTAL_OVERDUE_AMOUNT_BY_SUPPLIER.data
	);
	const [files, setFiles] = React.useState([]);
	const [filesNotPersisted, setFilesNotPersisted] = React.useState([]);
	const onloadFiles = (filesParam) => {
		setFiles(filesParam);
	};
	const onDeleteFile = (file) => {
		files.splice(files.indexOf(file), 1);
		toast.info(t("fileRemovedMsg", { filename: file.name }), { autoClose: 3000 });
	};

	// eslint-disable-next-line no-shadow
	const filterInvoices = useSelector(({ filterInvoices }) => filterInvoices);

	const onclickUploadInvoices = () => {
		files.forEach((element) => {
			dispatch(createInvoice(element)).then((response) => {
				if (response.status === 201) {
					toast.success(t("invoice_uploaded_success"));
				}
				dispatch(fetchInvoices(filterInvoices));
				dispatch(invoicesTotalAmounts([]));
				if (response.data && !isEmpty(response.data.nameFile)) {
					setFilesNotPersisted([...filesNotPersisted, response.data.nameFile]);
				}
			});
		});
	};
	const name = supplier?.code;
	useEffect(() => {
		if (currentUser && isSupplierOnly(get(currentUser, "roles", [])) && currentUser.supplierId !== props.match.params.idSupplier) {
			history.push(`/supplier/details/${currentUser.supplierId}`);
		}
		dispatch(fetchCountSuppliers());
		dispatch(fetchCountInvoices());
		dispatch(invoicesTotalAmountsOverDueBySupplier(props.match.params.idSupplier));
		dispatch(fetchSupplier(props.match.params.idSupplier));
		dispatch(fetchSupplierInvoices(props.match.params.idSupplier));
		dispatch(fetchOrdersBySupplier(props.match.params.idSupplier));
		dispatch(invoicesTotalAmountsBySupplier(props.match.params.idSupplier));
		dispatch(invoicesTotalAmountsBySupplier(props.match.params.idSupplier, "EXPORTED"));
		dispatch(invoicesTotalAmountsBySupplier(props.match.params.idSupplier, "UNPAID"));
		dispatch(invoicesVATAmountsBySupplier(props.match.params.idSupplier, "EXPORTED"));
		dispatch(fetchDeliveryItemsBySupplier(props.match.params.idSupplier));
	}, [dispatch, props.match.params.idSupplier]);

	const idInvoices = supplierInvoices ? supplierInvoices.map((e) => e.id) : [];
	const onClickRow = (id) => {
		history.push(`invoices/details/${id}`);
	};

	const handleChange = (event, newValue) => {
		setValue(newValue);
	};
	const handleChangeInformtionTab = (event, newValue) => {
		setValueI(newValue);
	};

	const onDrop = () => {
		// toast.success(t("fileAddedMsg"), { autoClose: 3000 });
	};

	return (
		<>
			{supplier ? (
				<Grid container xs={12} className={classes.rootContainer}>
					<Grid container item xs={8}>
						<Card className={classes.card}>
							<CardHeader
								className={classes.cardHeader}
								avatar={
									<Avatar alt="Remy Sharp" className={classes.avatar}>
										{supplier && supplier.logo ? (
											<img
												alt="icon"
												src={`${getApi()}/invoice${supplier.logo}`}
												className={classes.image}
											/>
										) : (
											<AccountCircle className={classes.logo} />
										)}
									</Avatar>
								}
							/>

							<Grid item container xs={12}>
								<Grid item container xs={12}>
									<Typography variant="h6" color="primary" className={classes.label}>
										{get(supplier, "label")}
									</Typography>
								</Grid>
								<Grid item container xs={12}>
									<Paper className={classes.paper}>
										<Tabs
											value={valueI}
											onChange={handleChangeInformtionTab}
											aria-label="Assets"
											variant="fullWidth"
											style={{ backgroundColor: "#fbfbfb" }}
										>
											<Tab
												label={t("legalInformation")}
												{...a11yProps(0)} // eslint-disable-line
												className={classes.tabb}
												classes={{ selected: classes.selectedTab2 }}
											/>
											<Tab
												label={t("generalInformation")}
												{...a11yProps(1)} // eslint-disable-line
												className={classes.tabb}
												classes={{ selected: classes.selectedTab2 }}
											/>

											<Tab
												label={t("financialInformation")}
												{...a11yProps(2)} // eslint-disable-line
												className={classes.tabb}
												classes={{ selected: classes.selectedTab2 }}
												align="Right"
											/>
											<Tab
												label={t("associatedContact")}
												{...a11yProps(3)} // eslint-disable-line
												className={classes.tabb}
												classes={{ selected: classes.selectedTab2 }}
											/>
										</Tabs>
									</Paper>
								</Grid>
								<Grid container item xs={12}>
									<SubPagePanel value={valueI} index={0} className={classes.fullwidth}>
										<DetailsLegalInformation supplier={supplier} />
									</SubPagePanel>
									<SubPagePanel value={valueI} index={3} className={classes.fullwidth}>
										<DetailsSupplierContact
											contact={supplier && supplier.contacts && supplier.contacts[0]}
										/>
									</SubPagePanel>
									<SubPagePanel value={valueI} index={2} className={classes.fullwidth}>
										<DetailsFinancialInformations supplier={supplier} />
									</SubPagePanel>
									<SubPagePanel value={valueI} index={1} className={classes.fullwidth}>
										<DetailsSupplierGeneral supplier={supplier} />
									</SubPagePanel>
								</Grid>
							</Grid>
						</Card>
					</Grid>
					<Grid continer item direction="column" xs={4} style={{ marginTop: "65px" }}>
						<Grid item xs={12} style={{ height: "220px" }}>
							<PaidInvoice
								elevation={26}
								square
								totalVatAmount={totalVatAmount}
								totalPaidAmount={totalInvoicesAmountPayed}
								style={{ background: "#f8f9fa" }}
								currentUser={currentUser}
							/>
						</Grid>
						<Grid item xs={12} style={{ height: "220px" }}>
							<UnpaidInvoice
								elevation={26}
								square
								unpaidIncoicesAmount={totalInvoicesAmountUnpaid}
								style={{ background: "#f8f9fa" }}
								overdue={totalAmountsOverDueBySupplier}
								currentUser={currentUser}
							/>
						</Grid>
					</Grid>
				</Grid>
			) : (
				<CircularLoader />
			)}
			<Grid container xs={12} className={classes.invoicesDetails}>
				<Grid container direction="column" item xs={6}>
					<Grid item>
						<Typography variant="h6" color="secondary">
							<span style={{ whiteSpace: "nowrap" }}>{t("Total amount of invoices")} :</span>{" "}
							<span style={{ whiteSpace: "nowrap" }}>
								{totalInvoicesAmount >= 0 ? (
									` ${currencyFormat(totalInvoicesAmount)} €`
								) : (
									<CircularLoader />
								)}
							</span>
						</Typography>
					</Grid>
					<Grid item>
						<Typography variant="subtitle2" color="textSecondary">
							{t("countInvoices")} :{" "}
							{supplierInvoices ? get(supplierInvoices, "length") : <CircularLoader />}
						</Typography>
					</Grid>
				</Grid>
			</Grid>

			<Grid container spacing={4} className={classes.invoicesTable}>
				<Grid item xs={12} sm={12}>
					<SubPageContainer>
						<Grid
							spacing={2}
							container
							item
							xs={12}
							className={classes.headerZone}
							justify="center"
							alignItems="stretch"
						>
							<Grid item xs={6}>
								<DropzoneArea
									expanded={expanded}
									showFileNames
									useChipsForPreview
									dropzoneClass={classes.dropzone}
									dropzoneParagraphClass={classes.text}
									onChange={onloadFiles}
									onDelete={onDeleteFile}
									onDrop={onDrop}
									zoneMessage="Add your Invoice"
									acceptedFiles={EXTENTIONS_INVOICES}
								/>
							</Grid>
							<Grid container item xs={2}>
								{expanded && (
									<Button
										fullWidth
										variant="contained"
										color="primary"
										className={classes.expand}
										onClick={(e) => {
											onclickUploadInvoices(e);
											setExpanded(!expanded);
										}}
									>
										{t("Upload")}
									</Button>
								)}
							</Grid>
						</Grid>
						{isSupplierOnly(get(currentUser, "roles", [])) && (
							<Grid container item xs={12} justify="flex-end">
								{!expanded && (
									<Button
										variant="contained"
										color="primary"
										className={classes.expand}
										onClick={() => {
											setExpanded(!expanded);
										}}
									>
										{t("Add an invoice")}
									</Button>
								)}
							</Grid>
						)}

						<Paper position="static" className={classes.appBar}>
							<Tabs
								value={value}
								onChange={handleChange}
								aria-label="Assets"
								className={classes.tabs}
							>
								<Tab
									label={t("Invoices")}
									{...a11yProps(0)} // eslint-disable-line
									classes={{ selected: classes.selectedTab }}
								/>
								<Tab
									label={t("Orders")}
									{...a11yProps(1)} // eslint-disable-line
									classes={{ selected: classes.selectedTab }}
								/>
								{value === 0 && (
									<Tooltip
										placement="top"
										title={t("tooltip.action.export_excel")}
										className={classes.tooltip}
									>
										<IconButton
											disabled={supplierInvoices && supplierInvoices.length === 0}
											aria-label="download"
											onClick={() => {
												setIsLoading({ ...isLoading, excel: true });
												dispatch(downloadInvoicesExcel(idInvoices, name, false)).then(() => {
													setIsLoading({ ...isLoading, excel: false });
												});
											}}
										>
											<LoadingButton isLoading={isLoading.excel}>
												<DescriptionIcon />
											</LoadingButton>
										</IconButton>
									</Tooltip>
								)}
							</Tabs>
						</Paper>
						<SubPagePanel value={value} index={0}>
							{get(supplierInvoices, "length") >= 0 ? (
								<InvoicesTable
									isDashboard
									isSupplierDetails
									supplierInvoices={supplierInvoices}
									totalInvoicesAmount={totalInvoicesAmount}
									onClickInvoice={onClickRow}
									downloadXMLInvoice={downloadXMLInvoice}
									idSupplier={props.match.params.idSupplier}
								/>
							) : (
								<CircularLoader />
							)}
						</SubPagePanel>
						<SubPagePanel value={value} index={1}>
							{get(orders, "length") >= 0 ? <OrderTable orders={orders} /> : <CircularLoader />}
						</SubPagePanel>
					</SubPageContainer>
				</Grid>
			</Grid>
		</>
	);
}

export default SupplierDetails;
